<template>
      <!--====== APPIE FOOTER PART START ======-->
    
    <section class="appie-footer-area">
        <div class="container">
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="footer-about-widget">
                        <div class="logo">
                            <a href="#"><img src="@/assets/images/logo-11.png" alt=""></a>
                        </div>
                        <p>TroFii is the First Picture Menu App</p>
                        <a href="#">Read More <i class="fal fa-arrow-right"></i></a>
                        <div class="social mt-30">
                            <ul>
                                <li><a target="_blank" href="https://www.facebook.com/trofiiapp/"><i class="fab fa-facebook-f"></i></a></li>
                                <!-- <li><a href="#"><i class="fab fa-twitter"></i></a></li> -->
                                <li><a target="_blank" href="https://www.instagram.com/trofiiapp/"><i class="fab fa-instagram"></i></a></li>
                                <!-- <li><a href="#"><i class="fab fa-linkedin-in"></i></a></li> -->
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-lg-2 col-md-6">
                    <div class="footer-navigation">
                        <h4 class="title">Company</h4>
                        <ul>
                            <li><router-link to="/about-us">About Us</router-link></li>
                            <li><router-link to="/service-details">Features</router-link></li>
                            <li><router-link to="/contact">Contact</router-link></li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="footer-navigation">
                        <h4 class="title">Support</h4>
                        <ul>
                            <!-- <li><a href="#">Community</a></li>
                            <li><a href="#">Resources</a></li> -->
                            <li><a href="/#faq">Faqs</a></li>
                            <li><a target="_blank" href="https://firebasestorage.googleapis.com/v0/b/worests.appspot.com/o/assets%2FPrivacy%20Policy%20for%20TroFii.html?alt=media&token=2424436f-568a-4e28-9adb-65f94bd026cc">Privacy Policy</a></li>
                            <li><a target="_blank" href="https://firebasestorage.googleapis.com/v0/b/worests.appspot.com/o/assets%2FTerms%20%26%20Conditions%20for%20TroFii.html?alt=media&token=4145a508-ff3d-4d1f-b423-4fcf04d729f2">Terms & Conditions</a></li>
                        </ul>
                    </div>                    
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="footer-widget-info">
                        <h4 class="title">Get In Touch</h4>
                        <ul>
                            <li><a href="mailto:Support@TroFii.Net" ><i class="fal fa-envelope"></i> Support@TroFii.Net</a></li>
                            <!-- <li><a href="#"><i class="fal fa-phone"></i> +(642) 342 762 44</a></li> -->
                            <!-- <li><a href="#"><i class="fal fa-map-marker-alt"></i> 442 Belle Terre St Floor 7, San Francisco, AV 4206</a></li> -->
                        </ul>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="footer-copyright d-flex align-items-center justify-content-between pt-35">
                        <div class="apps-download-btn">
                        <ul>
                            <li><a target="_blank" href="https://apps.apple.com/us/app/id1424083655"><i class="fab fa-apple"></i> Download for iOS</a></li>
                            <li><a target="_blank" class="item-2" href="https://play.google.com/store/apps/details?id=com.www.worests"><i class="fab fa-google-play"></i> Download for Android</a></li>
                        </ul>
                        </div>
                        <div class="copyright-text">
                            <p>Copyright © 2021 TroFii. All rights reserved.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    <!--====== APPIE FOOTER PART ENDS ======-->
</template>

<script>
export default {
    
}
</script>

<style>

</style>